import React from 'react';
import { IconSvgProps } from '@models/common';

const Like: React.FC<IconSvgProps> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M14.6 7.9999H21C21.5304 7.9999 22.0391 8.21062 22.4142 8.58569C22.7893 8.96076 23 9.46947 23 9.9999V12.1039C23.0003 12.3653 22.9493 12.6241 22.85 12.8659L19.755 20.3809C19.6795 20.5641 19.5513 20.7208 19.3866 20.831C19.2219 20.9412 19.0282 21 18.83 20.9999H2C1.73478 20.9999 1.48043 20.8945 1.29289 20.707C1.10536 20.5195 1 20.2651 1 19.9999V9.9999C1 9.73469 1.10536 9.48033 1.29289 9.2928C1.48043 9.10526 1.73478 8.9999 2 8.9999H5.482C5.6421 8.99994 5.79986 8.96155 5.94203 8.88794C6.08421 8.81433 6.20662 8.70766 6.299 8.5769L11.752 0.849904C11.8209 0.752217 11.9226 0.682464 12.0385 0.653294C12.1545 0.624124 12.277 0.637467 12.384 0.690904L14.198 1.5979C14.7085 1.85307 15.1163 2.27522 15.3537 2.79422C15.5911 3.31322 15.6438 3.89783 15.503 4.4509L14.6 7.9999ZM7 10.5879V18.9999H18.16L21 12.1039V9.9999H14.6C14.2954 9.99986 13.9948 9.93024 13.7212 9.79636C13.4476 9.66248 13.2082 9.46787 13.0213 9.22739C12.8343 8.98691 12.7048 8.7069 12.6425 8.40873C12.5803 8.11056 12.5869 7.80211 12.662 7.5069L13.565 3.9589C13.5933 3.84823 13.5828 3.73122 13.5353 3.62733C13.4878 3.52345 13.4062 3.43895 13.304 3.3879L12.643 3.0579L7.933 9.7299C7.683 10.0839 7.363 10.3739 7 10.5879ZM5 10.9999H3V18.9999H5V10.9999Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default Like;
